const e = "overline", t = "overline__text", o = {
  overline: e,
  overline__text: t
};
export {
  o as default,
  e as overline,
  t as overline__text
};
